import {Component, HostListener, OnInit} from "@angular/core";
import {PageService} from "../../service/page/page.service";
import { NewlinePipe } from "app/pipe/newline.pipe";
import {SliderV2} from "../../service/page/page";
import * as Swiper from "swiper";
import * as moment from "moment";


@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  providers: [PageService, NewlinePipe]
})
export class SliderComponent implements OnInit {
  config = {
    scrollbar: null,
    direction: 'horizontal',
    slidesPerView: 1,
    scrollbarHide: false,
    keyboardControl: false,
    mousewheelControl: false,
    scrollbarDraggable: true,
    scrollbarSnapOnRelease: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    autoplayStopOnLast: false,
    autoplayDisableOnInteraction: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    autoplay: 5000,
    loop: true,
    pagination: '.swiper-pagination',
    paginationType: 'bullets',
    paginationClickable: true,
  };
  sliders: SliderV2.Slide[];

  constructor(private pageService: PageService, private newLine: NewlinePipe) {
  }

  swiper;

  ngOnInit() {
    this.swiper = new Swiper('.swiper-main-slider', this.config);
    this.isMobile = (window.innerWidth < 768);
    this.onCarouselInit();
  }

  onCarouselInit() {
    this.pageService.getSliderV2().subscribe(
      res => {
        // 게시기간 및 전체 갯수 필터
        this.sliders = res.sliders
          .filter(({startTime, endTime}) => moment().isBetween(startTime,endTime))
          .slice(0,10)

        this.renderSwiper(this.sliders);
      }
    );
  }

  isMobile: boolean = false;
  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
      this.renderSwiper(this.sliders);
    }
  }

  renderSwiper(sliders) {
    this.swiper.removeAllSlides();
    this.swiper.appendSlide(sliders.map(
      slide => {
        let rtn = `<div class="swiper-slide" style="background-image:url('${this.isMobile ? slide.mobileImage : slide.image}')">`

        if(slide.title || slide.url || slide.buttonUrl) {
          rtn += `<div class="slide-inner">`
          rtn += (slide.title ? `<h1 class="slide-title">${this.newLine.transform(slide.title, [])}</h1>` : '')
          rtn += (slide.detail ? `<div class="slide-detail">${this.newLine.transform(slide.detail, [])}</div>` : '')
          rtn += (slide.buttonName && slide.buttonUrl && slide.buttonVisible ? 
            `<a class="slide-btn-link" href="${slide.buttonUrl}" target="${slide.newWindow ? '_blank' : '_self'}">
              ${slide.buttonName}
            </a>` : '')
          rtn += `</div>`
        }
      
        rtn += `</div>`
        
        return rtn
      })
    );
    this.swiper.update(true);
    this.swiper.slideTo(1, 0); 
  }
}


// WEBPACK FOOTER //
// ./src/app/home/slider/slider.component.ts